"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoriesIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
// eslint-disable-next-line css-modules/no-unused-class
const ConsumerNavIcon_module_css_1 = __importDefault(require("./ConsumerNavIcon.module.css"));
/**
 *
 */
function StoriesIcon(props) {
    const baseClasses = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.icon, { [ConsumerNavIcon_module_css_1.default.active]: props.active });
    const pathClasses = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.ba, ConsumerNavIcon_module_css_1.default.stroke);
    const titleId = "stories-icon-title";
    return ((0, jsx_runtime_1.jsxs)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: baseClasses, "aria-describedby": titleId, children: [(0, jsx_runtime_1.jsx)("title", { id: titleId, children: "Watch Snapchat Stories" }), (0, jsx_runtime_1.jsx)("path", { d: "M15.1038 5H21.33C21.896 5 22.5 5.52847 22.5 6.3673V21.6327C22.5 22.4715 21.896 23 21.33 23H15.1038C14.5377 23 13.9338 22.4715 13.9338 21.6327V6.3673C13.9338 5.52847 14.5377 5 15.1038 5ZM2.67002 1H8.8962C9.46225 1 10.0662 1.52847 10.0662 2.3673V17.6327C10.0662 18.4715 9.46225 19 8.8962 19H2.67002C2.10396 19 1.5 18.4715 1.5 17.6327V2.3673C1.5 1.52847 2.10396 1 2.67002 1Z", className: pathClasses, strokeWidth: "2" })] }));
}
exports.StoriesIcon = StoriesIcon;
//# sourceMappingURL=StoriesIcon.js.map